import { Icon } from "@design-system/Icon";
import { FlexRow } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { type ObjectiveTarget } from "@generated/client/graphql";
import dayjs from "dayjs";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import { type FC } from "react";

type TargetExampleDisplayProps = {
    target: ObjectiveTarget;
    unitShortName: string;
};

export const TargetExampleDisplay: FC<TargetExampleDisplayProps> = ({
    target,
    unitShortName,
}) => {
    dayjs.extend(LocalizedFormat);

    const displayDate = dayjs(target.date).format("LL");

    return (
        <FlexRow gap="7" alignItems="center" className="w-full text-primary">
            <FlexRow gap="3" alignItems="center">
                <FlexRow gap="1" alignItems="center">
                    <Text variant="body">{target.value}</Text>
                    <Text variant="body">{unitShortName}</Text>
                </FlexRow>
            </FlexRow>
            <FlexRow gap="6" alignItems="center">
                <Icon
                    name="arrowRight"
                    size="lg"
                    className="text-neutral-300"
                />
                <FlexRow gap="1" alignItems="center">
                    <Icon name="calendar" size="sm" />
                    <Text variant="body">{displayDate}</Text>
                </FlexRow>
            </FlexRow>
        </FlexRow>
    );
};
